import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import INFTProperties, { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import { IAvaxCatsCard } from '../Card/IAvaxCatsCard'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'

export default function AvaxCatsDetail(props: INFDetailFormatted) {
  const { tokenItem } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IAvaxCatsCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={
        detailTokenItem ? (
          <div>
            One of 1,000 cats living on the Avalanche C-Chain. Each AVAX CAT is completely unique with its own style
            based on a wide variety of attributes. From VR headsets to face tattoos and everything in between there's an
            AVAX CAT to suit anyone.
          </div>
        ) : (
          <></>
        )
      }
      tokenItemName={detailTokenItem ? detailTokenItem.name : ''}
      properites={getNFTProperties()}
      externalUrl={detailTokenItem?.externalUrl}
    >
      {detailTokenItem ? <img src={detailTokenItem.image} alt={detailTokenItem.name} /> : <NFTImageSkeleton />}
    </BaseDetail>
  )
}
